<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00004">
      CHAPTER II
    </h2>
<p class="calibre3">
      “Well, what's the matter at Tod's?”
     </p>
<p class="calibre3">
      And Felix moved a little forward in his chair, his eyes fixed with
      interest on Stanley, who was about to speak.
    </p>
<p class="calibre3">
      “It's that wife of his, of course. It was all very well so long as she
      confined herself to writing, and talk, and that Land Society, or whatever
      it was she founded, the one that snuffed out the other day; but now she's
      getting herself and those two youngsters mixed up in our local broils, and
      really I think Tod's got to be spoken to.”
     </p>
<p class="calibre3">
      “It's impossible for a husband to interfere with his wife's principles.”
       So Felix.
    </p>
<p class="calibre3">
      “Principles!” The word came from John.
    </p>
<p class="calibre3">
      “Certainly! Kirsteen's a woman of great character; revolutionary by
      temperament. Why should you expect her to act as you would act
      yourselves?”
     </p>
<p class="calibre3">
      When Felix had said that, there was a silence.
    </p>
<p class="calibre3">
      Then Stanley muttered: “Poor old Tod!”
     </p>
<p class="calibre3">
      Felix sighed, lost for a moment in his last vision of his youngest
      brother. It was four years ago now, a summer evening—Tod standing
      between his youngsters Derek and Sheila, in a doorway of his white,
      black-timbered, creepered cottage, his sunburnt face and blue eyes the
      serenest things one could see in a day's march!
    </p>
<p class="calibre3">
      “Why 'poor'?” he said. “Tod's much happier than we are. You've only to
      look at him.”
     </p>
<p class="calibre3">
      “Ah!” said Stanley suddenly. “D'you remember him at Father's funeral?—without
      his hat, and his head in the clouds. Fine-lookin' chap, old Tod—pity
      he's such a child of Nature.”
     </p>
<p class="calibre3">
      Felix said quietly:
    </p>
<p class="calibre3">
      “If you'd offered him a partnership, Stanley—it would have been the
      making of him.”
     </p>
<p class="calibre3">
      “Tod in the plough works? My hat!”
     </p>
<p class="calibre3">
      Felix smiled. At sight of that smile, Stanley grew red, and John refilled
      his pipe. It is always the devil to have a brother more sarcastic than
      oneself!
    </p>
<p class="calibre3">
      “How old are those two?” John said abruptly.
    </p>
<p class="calibre3">
      “Sheila's twenty, Derek nineteen.”
     </p>
<p class="calibre3">
      “I thought the boy was at an agricultural college?”
     </p>
<p class="calibre3">
      “Finished.”
     </p>
<p class="calibre3">
      “What's he like?”
     </p>
<p class="calibre3">
      “A black-haired, fiery fellow, not a bit like Tod.”
     </p>
<p class="calibre3">
      John muttered: “That's her Celtic blood. Her father, old Colonel Moray,
      was just that sort; by George, he was a regular black Highlander. What's
      the trouble exactly?”
     </p>
<p class="calibre3">
      It was Stanley who answered: “That sort of agitation business is all very
      well until it begins to affect your neighbors; then it's time it stopped.
      You know the Mallorings who own all the land round Tod's. Well, they've
      fallen foul of the Mallorings over what they call injustice to some
      laborers. Questions of morality involved. I don't know all the details. A
      man's got notice to quit over his deceased wife's sister; and some girl or
      other in another cottage has kicked over—just ordinary country
      incidents. What I want is that Tod should be made to see that his family
      mustn't quarrel with his nearest neighbors in this way. We know the
      Mallorings well, they're only seven miles from us at Becket. It doesn't
      do; sooner or later it plays the devil all round. And the air's full of
      agitation about the laborers and 'the Land,' and all the rest of it—only
      wants a spark to make real trouble.”
     </p>
<p class="calibre3">
      And having finished this oration, Stanley thrust his hands deep into his
      pockets, and jingled the money that was there.
    </p>
<p class="calibre3">
      John said abruptly:
    </p>
<p class="calibre3">
      “Felix, you'd better go down.”
     </p>
<p class="calibre3">
      Felix was sitting back, his eyes for once withdrawn from his brothers'
      faces.
    </p>
<p class="calibre3">
      “Odd,” he said, “really odd, that with a perfectly unique person like Tod
      for a brother, we only see him once in a blue moon.”
     </p>
<p class="calibre3">
      “It's because he IS so d—d unique.”
     </p>
<p class="calibre3">
      Felix got up and gravely extended his hand to Stanley.
    </p>
<p class="calibre3">
      “By Jove,” he said, “you've spoken truth.” And to John he added: “Well, I
      WILL go, and let you know the upshot.”
     </p>
<p class="calibre3">
      When he had departed, the two elder brothers remained for some moments
      silent, then Stanley said:
    </p>
<p class="calibre3">
      “Old Felix is a bit tryin'! With the fuss they make of him in the papers,
      his head's swelled!”
     </p>
<p class="calibre3">
      John did not answer. One could not in so many words resent one's own
      brother being made a fuss of, and if it had been for something real, such
      as discovering the source of the Black River, conquering Bechuanaland,
      curing Blue-mange, or being made a Bishop, he would have been the first
      and most loyal in his appreciation; but for the sort of thing Felix made
      up—Fiction, and critical, acid, destructive sort of stuff,
      pretending to show John Freeland things that he hadn't seen before—as
      if Felix could!—not at all the jolly old romance which one could
      read well enough and enjoy till it sent you to sleep after a good day's
      work. No! that Felix should be made a fuss of for such work as that really
      almost hurt him. It was not quite decent, violating deep down one's sense
      of form, one's sense of health, one's traditions. Though he would not have
      admitted it, he secretly felt, too, that this fuss was dangerous to his
      own point of view, which was, of course, to him the only real one. And he
      merely said:
    </p>
<p class="calibre3">
      “Will you stay to dinner, Stan?”
     </p>
<p class="calibre3">
<a id="link2HCH0003">
</a>
</p>
<div class="pg-boilerplate" id="calibre_pb_9"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?3129ddea